<template>
  <div style="height: 100%;background-color: #f7f8fa">
    <van-nav-bar v-if="$store.getters.userInfo && $store.getters.userInfo.bindCard > 0" left-arrow right-text="我的卡券"
      @click-right="goMyCards">
      <template #left>
        <van-icon name="shop" size="20" />
      </template>
    </van-nav-bar>

    <van-cell-group>
      <van-field v-model.trim="cardno" label="卡号" maxlength="10" placeholder="请输入卡号" />
      <van-field v-model.trim="cardPwd" label="卡密" placeholder="请输入对应的卡密" @input="cardPwdInp" />
    </van-cell-group>

    <div style="margin: 16px;">
      <van-button block class="login-btn" round type="info" @click="nextClick">激活</van-button>
    </div>

    <div style="margin: 16px;">
      <van-button block class="login-btn" plain round type="info" @click="scanCodeClick">扫一扫</van-button>
      <div style="margin-top: 8px;
            color: #999;
            font-size: 13px;
            text-align: center;
            height: 30px;
            line-height: 30px;
            display: flex;
            justify-content: center;">
        <van-icon name="info-o" size="13px" style="margin-top: 8px;margin-right: 4px" />
        扫描卡片二维码快速激活
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { bindCard, wx_get_jsapi_ticket } from "@/api/user";
import { wx_scan_qr } from "@/util/wxSdk";
import preventBack from "@/mixins/prevent-back";

export default {
  name: "bind-card",

  mixins: [preventBack],

  data() {
    return {
      cardno: '',
      cardPwd: '',
      pageUrl: ''
    }
  },

  created() {
    this.$store.dispatch('store_get_user_info')
  },

  methods: {
    goMyCards() {
      this.$router.push('/user-cards')
    },

    // 卡密输入
    cardPwdInp() {
      if (this.cardPwd.length > 0) {
        this.cardPwd = this.xReplace(this.cardPwd.substring(0, 19), 4)
      }
    },

    nextClick() {
      if (this.cardno === '') {
        Toast({ message: '卡号不能为空', duration: 1000 })
        return
      }

      if (this.cardPwd === '') {
        Toast({ message: '卡密不能为空', duration: 1000 })
        return
      }

      if (this.payPwd2 === '') {
        Toast({ message: '密码不能为空', duration: 1000 })
        return
      }

      bindCard(this.cardno, this.cardPwd.split('-').join('').toUpperCase()).then(res => {
        budo_log.info("#97 bindCard", res)

        if (res.code === 0) {
          Dialog({ message: '绑定卡券成功' }).then(() => {
            this.$store.dispatch("store_get_user_info").then(() => {
              //多选卡 id=10
              if (res.data === 10) {
                this.$router.push({ path: 'topic-detail', query: { topicId: '10', buyFlag: '1' } })
              } else if (sessionStorage.getItem("rc.redirect_topic_list") === "1") {
                this.$router.push({ path: 'topic-list' })
              } else {
                this.$router.push({ path: 'user-cards' })
              }
            })
          })

          return
        }

        Dialog({ message: (res ? res.msg : null) || JSON.stringify(res) }).then()
      })
    },

    // 分割线
    xReplace(str, length) {
      let re = new RegExp("[a-zA-Z0-9]{1," + length + "}", "g");
      let temp = str.match(re);
      return temp.join("-")
    },

    // 扫一扫
    scanCodeClick() {
      var url = window.location.href;

      let that = this
      wx_get_jsapi_ticket(encodeURIComponent(url)).then(res => {
        budo_log.debug("#144 wx_get_jsapi_ticket, href=", url, "res=", res)
        if (res.code === 0) {
          wx_scan_qr(res, (result) => {
            that.bind_card_by_key(result.resultStr);
          }, (err) => {
            budo_log.info("#149 启动扫描失败", err)
            Toast.fail('启动扫描失败, err=' + JSON.stringify(err) + ", res=" + JSON.stringify(res) + ", href=" + url)
          })
        }
      });
    },

    bind_card_by_key(key) {
      budo_log.info("#174 绑卡卡券：" + key)

      bindCard('', '', key).then(res => {
        if (res.code === 0) {
          Dialog({ message: '卡券绑定成功' }).then(() => {
            this.$store.dispatch("store_get_user_info").then(() => {
              // 多选卡 id=10
              if (res.data === 10) {
                this.$router.push({ path: 'seckill-detail' });
                return
              }

              this.$router.push({ path: 'user-cards' })
            })
          });
        } else {
          this.$notify('绑定卡券失败：' + res.msg)
        }
      })
    },
  },

  // 处理 ios url 兼容
  beforeRouteEnter(to, from, next) {
    if (('/web' + to.path) !== location.pathname || ('/web' + to.path) !== '/web' + to.fullPath) {
      budo_log.info("#160 beforeRouteEnter assign, to=", to, 'from=', from);
      location.assign('/web' + to.fullPath.split('?')[0])
    } else {
      budo_log.debug("#163 beforeRouteEnter next, to=", to, 'from=', from);
      next()
    }
  }
}
</script>

<style lang="scss" scoped></style>

